import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { SearchIcon, CalendarIcon, UserIcon, Users as UsersIcon, TrendingUpIcon, TrendingDownIcon, MapPinIcon, FileTextIcon, DownloadIcon, ClockIcon, CheckIcon, XIcon, AlertTriangleIcon, BuildingIcon, BarChart2Icon, ChevronDownIcon, ChevronUpIcon, PhoneIcon, MailIcon, FilterIcon, SlidersIcon, BookOpenIcon } from 'lucide-react';
// Mock data for customers
const customers = [{
  id: 1,
  name: 'Gemeente Rotterdam',
  industry: 'Overheid',
  totalTrainings: 24,
  lastTraining: new Date('2023-06-15'),
  upcomingTrainings: 3,
  revenue: 28500,
  growth: 12,
  status: 'active',
  contactPerson: 'Jan de Vries',
  contactEmail: 'j.devries@rotterdam.nl',
  contactPhone: '010-1234567',
  location: 'Rotterdam',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Logo_gemeente_Rotterdam.svg/1200px-Logo_gemeente_Rotterdam.svg.png',
  activities: [{
    id: 101,
    type: 'training',
    title: 'Sliptraining Basis',
    date: new Date('2023-06-15'),
    participants: 8,
    location: 'Rotterdam',
    status: 'completed'
  }, {
    id: 102,
    type: 'email',
    title: 'Offerte nieuwe training',
    date: new Date('2023-06-10'),
    status: 'sent'
  }, {
    id: 103,
    type: 'meeting',
    title: 'Evaluatiegesprek',
    date: new Date('2023-06-05'),
    status: 'completed'
  }]
}, {
  id: 2,
  name: 'Politie Nederland',
  industry: 'Overheid',
  totalTrainings: 42,
  lastTraining: new Date('2023-06-20'),
  upcomingTrainings: 5,
  revenue: 64200,
  growth: 8,
  status: 'active',
  contactPerson: 'Lisa Bakker',
  contactEmail: 'l.bakker@politie.nl',
  contactPhone: '088-1674000',
  location: 'Utrecht',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Politie_Nederland_logo.svg/1200px-Politie_Nederland_logo.svg.png',
  activities: [{
    id: 201,
    type: 'training',
    title: 'Defensief Rijden Gevorderd',
    date: new Date('2023-06-20'),
    participants: 12,
    location: 'Utrecht',
    status: 'completed'
  }, {
    id: 202,
    type: 'call',
    title: 'Telefonisch overleg planning',
    date: new Date('2023-06-18'),
    status: 'completed'
  }]
}, {
  id: 3,
  name: 'Shell Nederland',
  industry: 'Energie',
  totalTrainings: 18,
  lastTraining: new Date('2023-05-28'),
  upcomingTrainings: 2,
  revenue: 32400,
  growth: -3,
  status: 'active',
  contactPerson: 'Robert Jansen',
  contactEmail: 'r.jansen@shell.com',
  contactPhone: '070-3779111',
  location: 'Den Haag',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Shell_logo.svg/1200px-Shell_logo.svg.png',
  activities: [{
    id: 301,
    type: 'training',
    title: 'Veilig Rijden Basis',
    date: new Date('2023-05-28'),
    participants: 10,
    location: 'Rotterdam',
    status: 'completed'
  }, {
    id: 302,
    type: 'email',
    title: 'Nieuwe trainingsdata',
    date: new Date('2023-06-02'),
    status: 'sent'
  }]
}, {
  id: 4,
  name: 'Albert Heijn Distributie',
  industry: 'Retail',
  totalTrainings: 12,
  lastTraining: new Date('2023-06-01'),
  upcomingTrainings: 1,
  revenue: 18900,
  growth: 5,
  status: 'active',
  contactPerson: 'Marieke de Boer',
  contactEmail: 'm.deboer@ah.nl',
  contactPhone: '088-6562200',
  location: 'Zaandam',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Albert_Heijn_Logo.svg/1200px-Albert_Heijn_Logo.svg.png',
  activities: [{
    id: 401,
    type: 'training',
    title: 'Code 95 Training',
    date: new Date('2023-06-01'),
    participants: 15,
    location: 'Amsterdam',
    status: 'completed'
  }]
}, {
  id: 5,
  name: 'Brandweer Amsterdam',
  industry: 'Overheid',
  totalTrainings: 8,
  lastTraining: new Date('2023-04-15'),
  upcomingTrainings: 0,
  revenue: 12600,
  growth: -8,
  status: 'inactive',
  contactPerson: 'Peter Visser',
  contactEmail: 'p.visser@brandweer.nl',
  contactPhone: '020-5556555',
  location: 'Amsterdam',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Brandweer_Amsterdam-Amstelland_logo.svg/1200px-Brandweer_Amsterdam-Amstelland_logo.svg.png',
  activities: [{
    id: 501,
    type: 'training',
    title: 'Uitwijkmanoeuvres',
    date: new Date('2023-04-15'),
    participants: 8,
    location: 'Amsterdam',
    status: 'completed'
  }]
}];
export function CustomerActivity() {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState('last30days');
  const [showFilters, setShowFilters] = useState(false);
  const [sortBy, setSortBy] = useState('recent');
  const [expandedCustomer, setExpandedCustomer] = useState<number | null>(null);
  // Filter customers based on search term
  const filteredCustomers = customers.filter(customer => customer.name.toLowerCase().includes(searchTerm.toLowerCase()) || customer.industry.toLowerCase().includes(searchTerm.toLowerCase()) || customer.location.toLowerCase().includes(searchTerm.toLowerCase()));
  // Sort customers
  const sortedCustomers = [...filteredCustomers].sort((a, b) => {
    switch (sortBy) {
      case 'recent':
        return b.lastTraining.getTime() - a.lastTraining.getTime();
      case 'name':
        return a.name.localeCompare(b.name);
      case 'revenue':
        return b.revenue - a.revenue;
      case 'growth':
        return b.growth - a.growth;
      default:
        return 0;
    }
  });
  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };
  // Format date
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('nl-NL', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };
  // Get customer status badge
  const getCustomerStatusBadge = (status: string, growth: number) => {
    if (status === 'active') {
      return <Badge variant="success" dot={true} data-id="element-1863">
          Actief
        </Badge>;
    } else if (status === 'inactive') {
      return <Badge variant="warning" dot={true} data-id="element-1864">
          Inactief
        </Badge>;
    } else if (status === 'prospect') {
      return <Badge variant="info" dot={true} data-id="element-1865">
          Prospect
        </Badge>;
    }
  };
  // Get growth trend badge
  const getGrowthTrendBadge = (growth: number) => {
    if (growth > 0) {
      return <Badge variant="success" size="sm" className="flex items-center" data-id="element-1866">
          <TrendingUpIcon size={14} className="mr-1" data-id="element-1867" />+{growth}%
        </Badge>;
    } else if (growth < 0) {
      return <Badge variant="danger" size="sm" className="flex items-center" data-id="element-1868">
          <TrendingDownIcon size={14} className="mr-1" data-id="element-1869" />
          {growth}%
        </Badge>;
    } else {
      return <Badge variant="default" size="sm" data-id="element-1870">
          0%
        </Badge>;
    }
  };
  // Handle customer click
  const handleCustomerClick = (customer: any) => {
    setSelectedCustomer(customer);
    setActiveTab('overview');
  };
  // Toggle customer expansion
  const toggleCustomerExpansion = (customerId: number, e: React.MouseEvent) => {
    e.stopPropagation();
    setExpandedCustomer(expandedCustomer === customerId ? null : customerId);
  };
  // Render customer details
  const renderCustomerDetails = () => {
    if (!selectedCustomer) {
      return <div className="text-center py-12" data-id="element-1871">
          <BuildingIcon className="w-12 h-12 text-gray-300 mx-auto mb-4" data-id="element-1872" />
          <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-1873">
            Geen klant geselecteerd
          </h3>
          <p className="text-sm text-gray-500" data-id="element-1874">
            Selecteer een klant om details te bekijken
          </p>
        </div>;
    }
    switch (activeTab) {
      case 'overview':
        return <div className="space-y-6" data-id="element-1875">
            <div className="flex items-center justify-between" data-id="element-1876">
              <div className="flex items-center" data-id="element-1877">
                <div className="w-16 h-16 bg-white rounded-lg border border-gray-200 p-2 flex items-center justify-center mr-4" data-id="element-1878">
                  <img src={selectedCustomer.logo} alt={selectedCustomer.name} className="max-w-full max-h-full object-contain" data-id="element-1879" />
                </div>
                <div data-id="element-1880">
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-1881">
                    {selectedCustomer.name}
                  </h2>
                  <div className="flex items-center mt-1 space-x-2" data-id="element-1882">
                    <Badge variant="subtle" data-id="element-1883">{selectedCustomer.industry}</Badge>
                    {getCustomerStatusBadge(selectedCustomer.status, selectedCustomer.growth)}
                    {getGrowthTrendBadge(selectedCustomer.growth)}
                  </div>
                </div>
              </div>
              <div className="flex space-x-2" data-id="element-1884">
                <Button variant="outline" size="sm" icon={<FileTextIcon size={16} data-id="element-1886" />} data-id="element-1885">
                  Rapport
                </Button>
                <Button variant="primary" size="sm" icon={<MailIcon size={16} data-id="element-1888" />} data-id="element-1887">
                  Contact
                </Button>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1889">
              <Card className="col-span-1" data-id="element-1890">
                <div className="flex items-center" data-id="element-1891">
                  <div className="p-3 rounded-full bg-blue-100" data-id="element-1892">
                    <CalendarIcon className="h-6 w-6 text-blue-600" data-id="element-1893" />
                  </div>
                  <div className="ml-4" data-id="element-1894">
                    <h3 className="text-sm font-medium text-gray-500" data-id="element-1895">
                      Trainingen
                    </h3>
                    <p className="text-2xl font-semibold text-gray-900" data-id="element-1896">
                      {selectedCustomer.totalTrainings}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-1897">
                      Laatste op {formatDate(selectedCustomer.lastTraining)}
                    </p>
                  </div>
                </div>
              </Card>
              <Card className="col-span-1" data-id="element-1898">
                <div className="flex items-center" data-id="element-1899">
                  <div className="p-3 rounded-full bg-green-100" data-id="element-1900">
                    <TrendingUpIcon className="h-6 w-6 text-green-600" data-id="element-1901" />
                  </div>
                  <div className="ml-4" data-id="element-1902">
                    <h3 className="text-sm font-medium text-gray-500" data-id="element-1903">Omzet</h3>
                    <p className="text-2xl font-semibold text-gray-900" data-id="element-1904">
                      {formatCurrency(selectedCustomer.revenue)}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-1905">
                      {selectedCustomer.growth > 0 ? `+${selectedCustomer.growth}% t.o.v. vorig jaar` : `${selectedCustomer.growth}% t.o.v. vorig jaar`}
                    </p>
                  </div>
                </div>
              </Card>
              <Card className="col-span-1" data-id="element-1906">
                <div className="flex items-center" data-id="element-1907">
                  <div className="p-3 rounded-full bg-purple-100" data-id="element-1908">
                    <CalendarIcon className="h-6 w-6 text-purple-600" data-id="element-1909" />
                  </div>
                  <div className="ml-4" data-id="element-1910">
                    <h3 className="text-sm font-medium text-gray-500" data-id="element-1911">
                      Geplande Trainingen
                    </h3>
                    <p className="text-2xl font-semibold text-gray-900" data-id="element-1912">
                      {selectedCustomer.upcomingTrainings}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-1913">
                      {selectedCustomer.upcomingTrainings > 0 ? 'Eerstvolgende binnen 30 dagen' : 'Geen geplande trainingen'}
                    </p>
                  </div>
                </div>
              </Card>
            </div>
            <Card title="Contactgegevens" data-id="element-1914">
              <div className="space-y-4" data-id="element-1915">
                <div className="flex items-center" data-id="element-1916">
                  <UserIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-1917" />
                  <div data-id="element-1918">
                    <p className="text-sm font-medium text-gray-900" data-id="element-1919">
                      Contactpersoon
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1920">
                      {selectedCustomer.contactPerson}
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-1921">
                  <MailIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-1922" />
                  <div data-id="element-1923">
                    <p className="text-sm font-medium text-gray-900" data-id="element-1924">E-mail</p>
                    <p className="text-sm text-gray-600" data-id="element-1925">
                      <a href={`mailto:${selectedCustomer.contactEmail}`} className="text-[#B61C1C] hover:underline" data-id="element-1926">
                        {selectedCustomer.contactEmail}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-1927">
                  <PhoneIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-1928" />
                  <div data-id="element-1929">
                    <p className="text-sm font-medium text-gray-900" data-id="element-1930">
                      Telefoonnummer
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1931">
                      <a href={`tel:${selectedCustomer.contactPhone}`} className="text-[#B61C1C] hover:underline" data-id="element-1932">
                        {selectedCustomer.contactPhone}
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-center" data-id="element-1933">
                  <MapPinIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-1934" />
                  <div data-id="element-1935">
                    <p className="text-sm font-medium text-gray-900" data-id="element-1936">Locatie</p>
                    <p className="text-sm text-gray-600" data-id="element-1937">
                      {selectedCustomer.location}
                    </p>
                  </div>
                </div>
              </div>
            </Card>
            <Card title="Recente Activiteiten" actions={<Button variant="ghost" size="sm" data-id="element-1939">
                  Alles Bekijken
                </Button>} data-id="element-1938">
              <div className="space-y-4" data-id="element-1940">
                {selectedCustomer.activities.map((activity: any) => <div key={activity.id} className="flex items-start pb-4 border-b border-gray-200 last:border-0 last:pb-0" data-id="element-1941">
                    <div className={`p-2 rounded-full mr-3 ${activity.type === 'training' ? 'bg-blue-100' : activity.type === 'email' ? 'bg-green-100' : activity.type === 'meeting' ? 'bg-purple-100' : activity.type === 'call' ? 'bg-yellow-100' : 'bg-gray-100'}`} data-id="element-1942">
                      {activity.type === 'training' && <BookOpenIcon className="h-4 w-4 text-blue-600" data-id="element-1943" />}
                      {activity.type === 'email' && <MailIcon className="h-4 w-4 text-green-600" data-id="element-1944" />}
                      {activity.type === 'meeting' && <UsersIcon className="h-4 w-4 text-purple-600" data-id="element-1945" />}
                      {activity.type === 'call' && <PhoneIcon className="h-4 w-4 text-yellow-600" data-id="element-1946" />}
                    </div>
                    <div className="flex-1" data-id="element-1947">
                      <div className="flex justify-between" data-id="element-1948">
                        <p className="text-sm font-medium text-gray-900" data-id="element-1949">
                          {activity.title}
                        </p>
                        <span className="text-xs text-gray-500" data-id="element-1950">
                          {formatDate(activity.date)}
                        </span>
                      </div>
                      {activity.type === 'training' && <div className="mt-1 text-xs text-gray-600" data-id="element-1951">
                          <div className="flex items-center" data-id="element-1952">
                            <UsersIcon className="h-3 w-3 mr-1" data-id="element-1953" />
                            <span data-id="element-1954">{activity.participants} deelnemers</span>
                          </div>
                          <div className="flex items-center mt-1" data-id="element-1955">
                            <MapPinIcon className="h-3 w-3 mr-1" data-id="element-1956" />
                            <span data-id="element-1957">{activity.location}</span>
                          </div>
                        </div>}
                    </div>
                  </div>)}
              </div>
            </Card>
          </div>;
      case 'trainings':
        return <Card title="Trainingen" data-id="element-1958">
            <p className="text-gray-600" data-id="element-1959">Trainingsoverzicht komt hier</p>
          </Card>;
      case 'reports':
        return <Card title="Rapportages" data-id="element-1960">
            <p className="text-gray-600" data-id="element-1961">Rapportages komen hier</p>
          </Card>;
      case 'notes':
        return <Card title="Notities" data-id="element-1962">
            <p className="text-gray-600" data-id="element-1963">Notities komen hier</p>
          </Card>;
      default:
        return null;
    }
  };
  return <div className="space-y-6" data-id="element-1964">
      <div className="flex justify-between items-center" data-id="element-1965">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1966">Klantactiviteit</h1>
        <div className="flex space-x-2" data-id="element-1967">
          <Button variant="outline" size="sm" icon={<FilterIcon size={16} data-id="element-1969" />} onClick={() => setShowFilters(!showFilters)} data-id="element-1968">
            Filters
          </Button>
          <Button variant="primary" size="sm" icon={<DownloadIcon size={16} data-id="element-1971" />} data-id="element-1970">
            Exporteren
          </Button>
        </div>
      </div>
      {/* Search and filters */}
      <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0" data-id="element-1972">
        <div className="relative flex-1" data-id="element-1973">
          <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-1974" />
          <input type="text" placeholder="Zoek op klantnaam, branche, locatie..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1975" />
        </div>
        <div className="flex space-x-2" data-id="element-1976">
          <select className="border border-gray-300 rounded-md text-sm py-2 px-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-1977">
            <option value="last30days" data-id="element-1978">Laatste 30 dagen</option>
            <option value="last90days" data-id="element-1979">Laatste 90 dagen</option>
            <option value="lastYear" data-id="element-1980">Afgelopen jaar</option>
            <option value="allTime" data-id="element-1981">Alle tijd</option>
          </select>
          <select className="border border-gray-300 rounded-md text-sm py-2 px-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#B61C1C] focus:border-transparent" value={sortBy} onChange={e => setSortBy(e.target.value)} data-id="element-1982">
            <option value="recent" data-id="element-1983">Meest recent</option>
            <option value="name" data-id="element-1984">Naam (A-Z)</option>
            <option value="revenue" data-id="element-1985">Hoogste omzet</option>
            <option value="growth" data-id="element-1986">Hoogste groei</option>
          </select>
        </div>
      </div>
      {/* Filters panel */}
      {showFilters && <Card data-id="element-1987">
          <div className="p-4 space-y-4" data-id="element-1988">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1989">
              {/* Industry filter */}
              <div data-id="element-1990">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-1991">
                  Branche
                </h3>
                <div className="space-y-2" data-id="element-1992">
                  <div className="flex items-center" data-id="element-1993">
                    <input type="checkbox" id="industry-overheid" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-1994" />
                    <label htmlFor="industry-overheid" className="ml-2 text-sm text-gray-700" data-id="element-1995">
                      Overheid
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-1996">
                    <input type="checkbox" id="industry-energie" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-1997" />
                    <label htmlFor="industry-energie" className="ml-2 text-sm text-gray-700" data-id="element-1998">
                      Energie
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-1999">
                    <input type="checkbox" id="industry-retail" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2000" />
                    <label htmlFor="industry-retail" className="ml-2 text-sm text-gray-700" data-id="element-2001">
                      Retail
                    </label>
                  </div>
                </div>
              </div>
              {/* Status filter */}
              <div data-id="element-2002">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2003">
                  Status
                </h3>
                <div className="space-y-2" data-id="element-2004">
                  <div className="flex items-center" data-id="element-2005">
                    <input type="checkbox" id="status-active" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2006" />
                    <label htmlFor="status-active" className="ml-2 text-sm text-gray-700" data-id="element-2007">
                      Actief
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-2008">
                    <input type="checkbox" id="status-inactive" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2009" />
                    <label htmlFor="status-inactive" className="ml-2 text-sm text-gray-700" data-id="element-2010">
                      Inactief
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-2011">
                    <input type="checkbox" id="status-prospect" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2012" />
                    <label htmlFor="status-prospect" className="ml-2 text-sm text-gray-700" data-id="element-2013">
                      Prospect
                    </label>
                  </div>
                </div>
              </div>
              {/* Location filter */}
              <div data-id="element-2014">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-2015">
                  Locatie
                </h3>
                <div className="space-y-2" data-id="element-2016">
                  <div className="flex items-center" data-id="element-2017">
                    <input type="checkbox" id="location-rotterdam" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2018" />
                    <label htmlFor="location-rotterdam" className="ml-2 text-sm text-gray-700" data-id="element-2019">
                      Rotterdam
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-2020">
                    <input type="checkbox" id="location-amsterdam" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2021" />
                    <label htmlFor="location-amsterdam" className="ml-2 text-sm text-gray-700" data-id="element-2022">
                      Amsterdam
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-2023">
                    <input type="checkbox" id="location-utrecht" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2024" />
                    <label htmlFor="location-utrecht" className="ml-2 text-sm text-gray-700" data-id="element-2025">
                      Utrecht
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-2026">
                    <input type="checkbox" id="location-denhaag" className="h-4 w-4 text-[#B61C1C] focus:ring-[#B61C1C] border-gray-300 rounded" data-id="element-2027" />
                    <label htmlFor="location-denhaag" className="ml-2 text-sm text-gray-700" data-id="element-2028">
                      Den Haag
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pt-2 border-t border-gray-200" data-id="element-2029">
              <Button variant="outline" size="sm" onClick={() => setShowFilters(false)} data-id="element-2030">
                Annuleren
              </Button>
              <Button variant="primary" size="sm" data-id="element-2031">
                Filters Toepassen
              </Button>
            </div>
          </div>
        </Card>}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2032">
        {/* Customer list */}
        <div className="lg:col-span-1" data-id="element-2033">
          <Card title="Klanten" className="h-full" data-id="element-2034">
            <div className="space-y-1" data-id="element-2035">
              {sortedCustomers.length > 0 ? sortedCustomers.map(customer => <div key={customer.id} className="relative" data-id="element-2036">
                    <div className={`p-3 rounded-md cursor-pointer transition-all duration-200 ${selectedCustomer && selectedCustomer.id === customer.id ? 'bg-[#B61C1C]/10 border-l-4 border-[#B61C1C] pl-2' : 'hover:bg-gray-50 border-l-4 border-transparent pl-2'}`} onClick={() => handleCustomerClick(customer)} data-id="element-2037">
                      <div className="flex items-center justify-between" data-id="element-2038">
                        <div className="flex items-center space-x-3" data-id="element-2039">
                          <div className="w-8 h-8 bg-white rounded border border-gray-200 flex items-center justify-center overflow-hidden" data-id="element-2040">
                            <img src={customer.logo} alt={customer.name} className="max-w-full max-h-full object-contain" data-id="element-2041" />
                          </div>
                          <div data-id="element-2042">
                            <h3 className="text-sm font-medium text-gray-900 line-clamp-1" data-id="element-2043">
                              {customer.name}
                            </h3>
                            <div className="flex items-center text-xs text-gray-500 mt-0.5" data-id="element-2044">
                              <MapPinIcon className="h-3 w-3 mr-1" data-id="element-2045" />
                              <span data-id="element-2046">{customer.location}</span>
                            </div>
                          </div>
                        </div>
                        <button className="p-1 rounded-md hover:bg-gray-200 transition-colors" onClick={e => toggleCustomerExpansion(customer.id, e)} aria-label="Toggle details" data-id="element-2047">
                          {expandedCustomer === customer.id ? <ChevronUpIcon size={16} data-id="element-2048" /> : <ChevronDownIcon size={16} data-id="element-2049" />}
                        </button>
                      </div>
                      {expandedCustomer === customer.id && <div className="mt-3 pt-3 border-t border-gray-200 text-xs space-y-2" data-id="element-2050">
                          <div className="flex justify-between" data-id="element-2051">
                            <span className="text-gray-500" data-id="element-2052">
                              Laatste training:
                            </span>
                            <span className="font-medium" data-id="element-2053">
                              {formatDate(customer.lastTraining)}
                            </span>
                          </div>
                          <div className="flex justify-between" data-id="element-2054">
                            <span className="text-gray-500" data-id="element-2055">Trainingen:</span>
                            <span className="font-medium" data-id="element-2056">
                              {customer.totalTrainings}
                            </span>
                          </div>
                          <div className="flex justify-between" data-id="element-2057">
                            <span className="text-gray-500" data-id="element-2058">Omzet:</span>
                            <span className="font-medium" data-id="element-2059">
                              {formatCurrency(customer.revenue)}
                            </span>
                          </div>
                          <div className="flex justify-between" data-id="element-2060">
                            <span className="text-gray-500" data-id="element-2061">Groei:</span>
                            <span data-id="element-2062">{getGrowthTrendBadge(customer.growth)}</span>
                          </div>
                        </div>}
                    </div>
                  </div>) : <div className="flex flex-col items-center justify-center py-6 text-center" data-id="element-2063">
                  <BuildingIcon className="h-12 w-12 text-gray-300 mb-2" data-id="element-2064" />
                  <p className="text-gray-500 text-sm" data-id="element-2065">
                    Geen klanten gevonden die voldoen aan de zoekcriteria
                  </p>
                </div>}
            </div>
          </Card>
        </div>
        {/* Customer details */}
        <div className="lg:col-span-2" data-id="element-2066">
          <Card className="h-full" data-id="element-2067">
            {selectedCustomer && <div className="border-b border-gray-200" data-id="element-2068">
                <div className="flex space-x-1" data-id="element-2069">
                  <button className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'overview' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('overview')} data-id="element-2070">
                    Overzicht
                  </button>
                  <button className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'trainings' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('trainings')} data-id="element-2071">
                    Trainingen
                  </button>
                  <button className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'reports' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('reports')} data-id="element-2072">
                    Rapportages
                  </button>
                  <button className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${activeTab === 'notes' ? 'border-[#B61C1C] text-[#B61C1C]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('notes')} data-id="element-2073">
                    Notities
                  </button>
                </div>
              </div>}
            <div className="p-4" data-id="element-2074">{renderCustomerDetails()}</div>
          </Card>
        </div>
      </div>
    </div>;
}